import { render, staticRenderFns } from "./environment_folder.vue?vue&type=template&id=0bbd16da"
import script from "./environment_folder.vue?vue&type=script&lang=js"
export * from "./environment_folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports